<template>
    <div class="mt-2">

        <v-container>
            <v-layout row wrap class="justify-space-around">
                <v-flex xs12 sm12 md9 >
                    <v-card class="mx-2">
                        <v-card-text>
                            <div>
                                <h1>Les sanctions pour alcool au volant</h1>
                                <p>
                                    En 2017, un tiers des accidents mortels en voiture ont été causés par l’alcool au volant, soit
                                    1035 victimes. Ainsi, l’alcoolémie constitue la deuxième cause d’accidents mortels derrière
                                    les excès de vitesse.
                                </p>
                                <p>Conduire en état d’ivresse peut entraîner :</p>
                                <ul>
                                    <li>Un retrait de 6 points sur le permis de conduire</li>
                                    <li>135 euros d’amende.</li>
                                </ul>
                            </div>

                            <div>
                                <h2>Les sanctions encourues pour alcool au volant</h2>
                                <p>
                                    Un retrait automatique de 6 points est infligé à tout conducteur possédant un taux d’alcoolo
                                    supérieur ou égala à la limite autorisée ou refusant de subir un dépistage.
                                </p>
                                <p>
                                    Selon le degré d’alcoolisation du conducteur, des sanctions supplémentaires peuvent lui être
                                    appliquées.
                                </p>
                                <h3>Cas d’alcoolémie supérieure ou égal à 0,2 gramme par litre de sang en période probatoire</h3>
                                <p>0,2 grammes d’alcool/litre de sang correspond à 0,10 mg d’alcool/litre d’air expiré.</p>
                                <p>
                                    Le taux d’alcool autorisé pour les permis probatoires a été abaissé en date du 1 er juillet 2015.
                                    Ainsi, les jeunes conducteurs sont sanctionné pour toute conduite avec un taux d’alcoolémie
                                    supérieur à 0,2g/litre de sang. Ce taux correspondant à aucun verre d’alcool, on parle donc
                                    de tolérance zéro.
                                </p>
                                <p>Un taux supérieur ou égal à 0,20 g/l de sang entraîne :</p>
                                <ul>
                                    <li>Un retrait de 6 points</li>
                                    <li>135 euros d’amende</li>
                                    <li>Un risque de suspension du permis de conduire</li>
                                </ul>
                                <p>
                                    Conduire sous l’emprise de l’alcool pendant la première année de probation consiste en une
                                    infraction qui peut conduire au retrait du permis de conduire. Perdre 6 points engendre un
                                    solde nul et donc une invalidation du permis de conduire. Il est alors impossible de suivre un
                                    stage de récupération de points.
                                </p>
                                <p>
                                    Sauver son permis de conduire en toute légalité est cependant possible en cas d’alcoolémie
                                    non-délictuelle,
                                </p>
                            </div>

                            <div>
                                <h2>Nos conseils</h2>
                                <p>
                                    S’il existe un délai d’1 mois maximum entre la date du premier anniversaire de votre permis
                                    de conduire et la réception de l’avis de contravention, et en l’absence d’autres infractions,
                                    vous pouvez régler votre amende pour alcoolémie au volant une fois la date de première
                                    année de votre permis passée.
                                </p>

                                <p>N’oubliez pas que vous disposez d’un délai de 45 jours avant que votre amende soit
                                    majorée.
                                </p>
                                <p>
                                    Cette astuce légale permet que le déclenchement du retrait de points se fasse au moment
                                    du règlement de l’amende. Vous disposerez d’un solde de points de 2/8 une fois l’amende
                                    payée.
                                </p>
                                <p>
                                    Après avoir reçu la lettre 48N qui vous signifie l’obligation de participer à un stage de
                                    récupération de points, vous disposez d’un délai de 4 mois pour effectuer votre inscription à
                                    une session de stage qui vous permettra de récupérer 4 points. À son issue, vous possèderez
                                    un solde de 6/8.
                                </p>

                                <h3>Les risques encourus pour un taux l’alcoolémie compris entre 0,5 et 0,8 grammes par litre
                                    de sang</h3>
                                <p>Rappel : 0,5 g d’alcool / litre de sang = 0,25 mg d’alcool / litre d’air expiré</p>
                                <p>0,8 g d’alcool / litre de sang = 0,40 mg d’alcool / litre d’air expiré</p>
                                <p>Conduire en ayant un taux d’alcoolémie situé entre 0,5 g et 0,8 g / litre de sang engendre
                                    une contravention. Les sanctions encourues sont :</p>
                                <ul>
                                    <li>Un retrait de 6 points</li>
                                    <li>135 euros d’amende</li>
                                    <li>Risque de suspension du permis de conduire</li>
                                </ul>

                                <h3>Les risques encourus pour un taux d’alcoolémie supérieur à 0,8 gramme par litre de sang</h3>
                                <p>Rappel : 0,8 g d’alcool / litre de sang = 0,40 mg d’alcool / litre d’air expiré.</p>
                                <p>Conduire en ayant un taux d’alcoolémie supérieur à 0,8 g / litre de sang consiste un délit.
                                    Ainsi, des sanctions immédiates sont appliquées par les forces de l’ordre. S’ensuivent des
                                    sanctions judiciaires.</p>
                                <ul>
                                    <li>Un retrait de 6 points</li>
                                    <li>Passage au tribunal et suspension du permis de conduire</li>
                                </ul>
                                <h3>Au moment de l’infraction, les forces de l’ordre peuvent :</h3>
                                <ul>
                                    <li>Retenir pendant 72 heures le permis de conduire d’un conducteur en état d’ébriété
                                        manifeste</li>
                                    <li>Immobiliser le véhicule dans le cas où aucun passager n’est en capacité de prendre le
                                        volant</li>
                                    <li>Suspendre le permis administrativement pour une durée maximum de 6 mois ou, s’il
                                        ne s’agit ni d’une récidive ni d’un taux d’alcoolémie supérieur à 1,8 g, obliger
                                        d’équiper le véhicule d’un éthylotest anti-démarrage</li>
                                </ul>
                                <h3>Le tribunal peut, quant à, lui décider de :</h3>
                                <ul>
                                    <li>Une amende de 4 500 euros</li>
                                    <li>Une peine de prison qui peut aller jusqu’à 2 ans</li>
                                    <li>Suspendre le permis jusqu’à 3 ans, sans permis blanc ni sursis</li>
                                    <li>Annuler le permis de conduire et, si récidive, interdire la sollicitation d’un nouveau
                                        permis pendant au moins 3 ans</li>
                                    <li>Interdire la conduite de certains véhicules, même ceux qui ne nécessitent pas de
                                        permis de conduire.</li>
                                    <li>Interdire la conduite d’un véhicule qui ne comporte pas d’éthylotest anti-démarrage
                                        (EAD) homologué, pendant 5 ans maximum. Violer cette interdiction est un délit puni
                                        d’une amende de 4 500 euros et de 2 ans d’emprisonnement.</li>
                                    <li>Suivre un stage obligatoire de sensibilisation à la sécurité routière aux frais du
                                        contrevenant.</li>
                                </ul>
                            </div>

                            <div>
                                <h2>Une alternative à la suspension de permis : installer un éthylotest anti-
                                    démarrage</h2>
                                <p>Suite au décret du 18 septembre 2018, les conducteurs peuvent se voir imposer par les
                                    préfets, en cas de conduire avec un taux d’alcoolémie délictuel, l’installation d’un éthylotest
                                    anti-démarrage. La mise en place de ce dispositif évite permet d’éviter la suspension du
                                    permis de conduire. Elle doit être effectuée pour une durée maximum de 6 mois, dans
                                    l’attente de la convocation au tribunal.
                                </p>
                                <p>
                                    Cette durée peut être prolongée jusqu’à un maximum de 5 ans par le juge, lors de la
                                    comparution au tribunal.
                                </p>
                                <p>
                                    Cependant, les récidivistes ainsi que les conducteurs contrôlés avec un taux d’alcoolémie
                                    supérieur à 1,8 g n’ont pas accès à cette seconde chance.
                                </p>
                                <p>
                                    Ne pas respecter l’installation d’un éthylotest antidémarrage peut engendrer des sanctions :
                                </p>
                                <ul>
                                    <li>Une amende de 4 500 euros</li>
                                    <li>Une peine allant jusqu’à 2 ans d’emprisonnement</li>
                                    <li>Une annulation du permis de conduire pour un maximum de 3 ans.</li>
                                </ul>
                            </div>

                            <div>
                                <h2>Les sanctions encourues en cas de récidive de délit d’alcool</h2>
                                <p>On considère comme étant récidiviste une personne qui a déjà été condamnée à 2 reprises
                                    pour le même délit, dans un délai de 5 ans.</p>
                                <p>Si un conducteur est contrôlé pour la seconde fois de façon positive dans un délai de 5 ans, il
                                    passera automatiquement au tribunal.
                                </p>
                                <p>Les sanctions suivantes peuvent être prononcées par le juge :</p>
                                <ul>
                                    <li>Une annulation du permis jusqu’à un maximum de 3 ans</li>
                                    <li>La confiscation du véhicule sous réserve qu’il appartienne au contrevenant.</li>
                                </ul>
                                <p>
                                    La récupération du droit de conduire est soumise à une visite médicale et un test
                                    psychotechnique que doivent passer le contrevenant.
                                </p>
                                <p>
                                    Dans le cas où il est déclaré apte à conduire, il pourra alors repasser le code de la route ainsi
                                    que l’examen de conduite du permis.
                                </p>
                                <p>
                                    Une fois le permis de conduire obtenu, le conducteur se verra remettre un permis
                                    probatoire.
                                </p>
                            </div>

                            <div>
                                <h2>Le refus de se soumettre au dépistage d’alcoolémie</h2>
                                <p>Tout conducteur qui émet un refus face à un dépistage d’alcool effectué par éthylotest ou
                                    prise de sang encourt des sanctions identiques à une alcoolémie délictuelle supérieure ou
                                    égale à 0,8 grammes par litre de sang.</p>
                            </div>

                            <div>
                                <h2>Quels sont les effets de l’alcool ?</h2>
                                <p>IL ne faut ni atteindre ni encore moins dépasser le taux de 0,5 g d’alcool / litre de
                                    sang. Ceci correspond à deux verres d’alcool. Adopter un comportement
                                    responsable consiste à ne boire qu’un seul verre, c’est-à-dire une demi-bière, un
                                    verre de vin, ou 3cl d’alcool distillé à 40° (gin, whisky…).
                                </p>
                                <p>On retrouve environ 10 grammes d’alcool pur dans tous ces exemples.</p>
                                <p>
                                    Il faut savoir que chaque nouveau verre bu engendre une augmentation du taux
                                    d’alcoolémie de 0,20 à 0,25 gramme, voire 0,30 gramme pour les personnes

                                    âgées, les femmes ou les personnes les plus minces. L’élimination de l’alcool se
                                    fait beaucoup plus lentement, puisqu’il faut compter 1 heure pour éliminer 0,10 g
                                    à 0,15 gramme d’alcool. Manger, absorber de l’huile ou du sel n’accélère en rien
                                    ce mécanisme.
                                </p>

                                <h3>Les impacts de la consommation d’alcool sur le corps</h3>
                                <ul>
                                    <li>Rétrécissement du champ visuel</li>
                                    <li>Augmentation de la sensibilité à la lumière</li>
                                    <li>Altération des notions de distance et de largeur</li>
                                    <li>Ralentissement des réflexes</li>
                                    <li>Augmentation du sentiment de confiance pour le conducteur</li>
                                </ul>
                                <p>
                                    La conduite se retrouve dégradée par tous ces symptômes. De plus, le conducteur va être
                                    amené à prendre davantage de risque. Il va être agressif, posséder moins de réflexes et
                                    omettre de porter son casque ou sa ceinture de sécurité.
                                </p>
                                <p>
                                    La conduite en état d’alcoolémie peut entraîner la mort d’un autre usager de la route. Cette
                                    situation peut entraîner :
                                </p>
                                <ul>
                                    <li>Une amende de 150 000 euros</li>
                                    <li>Une peine allant jusqu’à 10 ans d’emprisonnement.</li>
                                </ul>
                            </div>

                            <div>
                                <h1>Article 234-1 du code de la route.</h1>
                                <p>Concernant l’alcool au volant, la loi est très claire : il est interdit de conduire ou
                                    d’accompagner un élève conducteur avec un taux d’alcool dans le sang égal ou
                                    supérieur à 0,5 gramme (soit 0,25 milligramme par litre d’air expiré). Prendre la
                                    route devient dangereux et l’on s’expose en plus à des sanctions. Celles-ci varient
                                    selon le taux d’alcoolémie, s’il y a eu un accident ou encore lorsque le conducteur
                                    refuse le dépistage.</p>
                                <p>
                                    Les forces de l’ordre pratiquent régulièrement des dépistages. Or, chaque véhicule
                                    doit contenir un éthylotest valide, en bon état de fonctionnement et comportant
                                    les normes de conformité en vigueur. Ceci est obligatoire depuis juillet 2012. Cette
                                    mesure a pour objectif de responsabiliser les conducteurs et de les inciter à
                                    effectuer un auto-contrôle de leur alcoolémie avant de prendre le volant.
                                </p>
                                <h3>Nos conseils</h3>
                                <ul>
                                    <li>Ne consommez ni alcool ni drogue avant de prendre la route</li>
                                    <li>Utilisez un éthylotest avant de conduire si vous avez bu de l’alcool.</li>
                                    <li>Si le test se révèle positif, ne prenez pas le volant. Désignez au préalable un
                                        capitaine de soirée qui ne boira aucun alcool et sera ainsi parfaitement apte
                                        à conduire et à ramener tout le monde tranquillement chez soi.</li>
                                </ul>
                            </div>

                        </v-card-text>
                    </v-card>

                </v-flex>
                <v-flex xs12 sm12 md3>
                    <v-card class="mx-2">
                        <v-card-text>
                            <RightAsideInfractions></RightAsideInfractions>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <Footer />
    </div>
</template>

<script>
    import RightAsideInfractions from '@/components/RightAsideInfractions'
    import Footer from '@/components/Footer'

    export default {
        name: "stage-recuperation-points",
        components: {
            RightAsideInfractions,
            Footer
        }
    }
</script>

<style>
    .highlighted {
        background: #ffedf5;
        border-radius: 10px;
        color: #7a0439;
        font-size: 18px;
        font-weight: 800;
        padding: 10px;
    }

    .highlighted p {
        font-size: 18px;
    }

    ul li {
        list-style-type: circle;
        margin: 10px 0 10px 0;
    }

    a {
        text-decoration: none;
    }

    a:hover {
        color: black;
    }

    p {
        font-size: 16px;
    }
</style>
